module.exports = __webpack_public_path__ + "img/ios.66b8b7ff.svg";